import AmexGDAEditorialCard from './AmexGDAEditorialCard';

export default AmexGDAEditorialCard;
